import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { RequestState } from '@shared/models/request-state';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { FlightTotals } from '../flight-totals';


@Injectable({
  providedIn: 'root'
})

export class FlightTotalsService {

  private readonly _url = environment.apiUrl;
  _isRefresh = new BehaviorSubject<boolean>(false);
  isRefresh$ = this._isRefresh.asObservable();

  constructor(
    private apiCacheService: ApiCacheService
  ) { }

  getFlightTimeStats(empNum: string, isRefresh = false): Observable<RequestState<FlightTotals>> {

    const cacheId = `${empNum}-fltStats`;
    const url = `${this._url}/Stats/flightTime/${empNum}`;

    if(!isRefresh) {
      return this.apiCacheService.request<FlightTotals>(cacheId, url, undefined);
    }
    else {
      return this.apiCacheService.forceRefreshGet<FlightTotals>(cacheId, url, undefined);
    }
    
  }
}

